const legalModal = document.getElementById("v_legal_informations");
if (legalModal) {
  const html = document.querySelector("html");

  html.style.overflow = "hidden";
  setTimeout(() => {
    const legalAcceptButton = document.getElementById(
      "v_legal_informations_modal__accept"
    );
    legalAcceptButton.addEventListener("click", function () {
      legalModal.style.display = "none";
      html.style.overflowX = "hidden";
      html.style.overflowY = "auto";
    });
  }, 1000);
}
